import { combineReducers } from 'redux'
import keycloak from './keycloak';
import language from './language'
import reservation from './reservation'
import backgroundRunning from './backgroundRunning'
import contextInfo from './contextInfo'
import conference from './conference'
import userProfileHistory from './userProfileHistory'
import paymentHistory from './paymentHistory'
import cancelMemberShip from './cancelMemberShip'
import messageNoti from './messageNoti'
import myRecordsUsage from './myRecordsUsage'
import cloudRecords from './cloudRecords'
import packageLists from './packageLists';

const rootReducer = combineReducers({
    keycloak,
    language,
    reservation,
    backgroundRunning,
    contextInfo,
    conference,
    userProfileHistory,
    paymentHistory,
    cancelMemberShip,
    messageNoti,
    myRecordsUsage,
    cloudRecords,
    packageLists,
})

export default rootReducer